import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleInvalid = this.handleInvalid.bind(this)
    this.clearMessage = this.clearMessage.bind(this)
    this.element.addEventListener("invalid", this.handleInvalid, true)
    this.element.addEventListener("input", this.clearMessage, true)
    this.element.addEventListener("change", this.clearMessage, true)
  }

  disconnect() {
    this.element.removeEventListener("invalid", this.handleInvalid, true)
    this.element.removeEventListener("input", this.clearMessage, true)
    this.element.removeEventListener("change", this.clearMessage, true)
  }

  handleInvalid(event) {
    const field = event.target
    if (typeof field.setCustomValidity !== "function") return

    event.preventDefault()
    field.setCustomValidity("")
    const message = this.messageFor(field)
    field.setCustomValidity(message)
    const shouldFocus = !field.form?.querySelector("[aria-invalid='true']")

    const errorId = `${field.id}-validation-error`
    let error = document.getElementById(errorId)
    if (!error) {
      error = document.createElement("p")
      error.id = errorId
      error.className = "form-client-error"
      error.setAttribute("role", "alert")
      field.insertAdjacentElement("afterend", error)
    }
    error.textContent = message

    const describedBy = new Set((field.getAttribute("aria-describedby") || "").split(" ").filter(Boolean))
    describedBy.add(errorId)
    field.setAttribute("aria-describedby", Array.from(describedBy).join(" "))
    field.setAttribute("aria-invalid", "true")
    if (shouldFocus) field.focus()
  }

  clearMessage(event) {
    const field = event.target
    if (typeof field.setCustomValidity !== "function") return

    field.setCustomValidity("")
    const errorId = `${field.id}-validation-error`
    document.getElementById(errorId)?.remove()
    field.removeAttribute("aria-invalid")

    const describedBy = (field.getAttribute("aria-describedby") || "").split(" ").filter((id) => id && id !== errorId)
    if (describedBy.length) {
      field.setAttribute("aria-describedby", describedBy.join(" "))
    } else {
      field.removeAttribute("aria-describedby")
    }
  }

  messageFor(field) {
    const validity = field.validity

    if (validity.valueMissing) {
      if (field instanceof HTMLSelectElement) return "Vyberte prosím jednu z možností."
      if (["checkbox", "radio"].includes(field.type)) return "Zaškrtněte prosím toto pole."
      return "Vyplňte prosím toto pole."
    }
    if (validity.typeMismatch && field.type === "email") return "Zadejte platnou e-mailovou adresu."
    if (validity.tooShort) return `Zadejte alespoň ${field.minLength} znaků.`
    if (validity.rangeUnderflow) return `Zadejte hodnotu alespoň ${field.min}.`
    if (validity.badInput) return "Zadejte platné číslo."

    return "Zkontrolujte prosím zadanou hodnotu."
  }
}
